function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/abm/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const AbmRoutes = [
  {
    path: '/abm/dashboard',
    component: view('Dashboard'),
    name: 'abm.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/abm/moveout',
    component: view('Inventory'),
    name: 'abm.moveout',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Move out',
          active: true
        }
      ]
    }
  }
]

export default AbmRoutes
